module.exports = __webpack_public_path__ + "resources/smileys-947dc6572c40c9850c952e659549af40.svg";